export const VNORDERS_STATES = {
  LOCAL: 'LOCAL',
  TOTALED: 'TOTALED',
}

export const VNORDERS_ACTIONS = {
  START_ORDER: 'START_ORDER',
  TOTAL_ORDER: 'TOTAL_ORDER',
}

export const VNORDERS_FEATURE_ENABLED = false
